export const HOST_REMINDER_INTERVAL_MS = 30_000;

export interface HostJoinReminder {
  id: string;
  title: string;
  meetingCode: string;
  status: string;
  startTime: string | null;
  endTime: string | null;
}
export interface HostJoinReminderResponse {
  serverTime: string;
  repeatAfterSeconds: number;
  meetings: HostJoinReminder[];
}

// Use the time of the last successful check. A cooldown expiring by itself must
// not reopen an old invitation to a meeting that has since ended or been disabled.
export function nextHostReminder(meetings: HostJoinReminder[], activeCode: string | null,
  dismissedUntil: Record<string, number>, checkedAt: number): HostJoinReminder | undefined {
  return meetings.find(meeting => meeting.meetingCode !== activeCode &&
    ['scheduled', 'prepared', 'in_progress'].includes(meeting.status) &&
    (dismissedUntil[meeting.id] ?? 0) <= checkedAt);
}
